export const fonts = {
  arvo: 'Arvo',
  poppins: 'Poppins',
  archivo: 'Archivo',
  nunito: 'Nunito Sans',
};
